
import { defineComponent } from 'vue';
import OutlineButton from '@/components/ui/OutlineButton.vue';
import proposalsService from '@/services/proposals.service';
import { AppMutation } from '@/store/app/app.mutation';
import { NotificationType } from '@/store/app/notification/notification-type';
import { ProposalAction } from '@/store/proposal/proposal.action';
import { ProposalExportType } from '@/model/proposal-export-type';

export default defineComponent({
  name: "ProposalDraftActions",
  components: {OutlineButton},
  props: {
    clientId: {
      type: Number,
      required: true
    },
    proposalId: {
      type: String,
      required: true
    },
    isSaving: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      isImporting: false
    }
  },
  methods: {
    exportXlsx(): void {
      this.$store.dispatch(ProposalAction.EXPORT_PROPOSAL, {
        proposalId: this.proposalId,
        type: ProposalExportType.XLSX,
        forImport: true
      });
    },
    triggerFileInput(): void {
      (this.$refs.fileInput as HTMLInputElement).click();
    },
    handleFileSelect(event: Event): void {
      const input = event.target as HTMLInputElement;
      const file = input.files?.[0];

      if (!file) return;

      this.isImporting = true;

      proposalsService.import(this.proposalId, file)
        .then(({ data }) => {
          this.$store.commit(AppMutation.ADD_NOTIFICATION, {
            type: NotificationType.SUCCESS,
            title: 'general.notifications.success',
            content: data.message
          });

          // Reload the page to reflect all updated values (prices and gross margins)
          window.location.reload();
        })
        .catch((error) => {
          const errorData = error.response?.data;
          const errorMessage = errorData?.errors?.join('\n') || errorData?.message || 'Import failed';

          this.$store.commit(AppMutation.ADD_NOTIFICATION, {
            type: NotificationType.ERROR,
            title: 'general.notifications.error',
            content: errorMessage
          });
        })
        .finally(() => {
          this.isImporting = false;
          // Reset the file input so the same file can be selected again
          input.value = '';
        });
    }
  }
})
